<template>
  <div :class="classes" v-if="data">
    <div class="vi-help--item__title">
      <b>{{data && data.type === 2 ? '使用指南' : '运营指导'}}</b>
    </div>
    <div class="vi-help-guide--pdf" @click="onDownload" v-if="data && data.annexDoc">
      <i class="pdf"></i>
      <span>{{data && data.docName || '-'}}</span>
    </div>
    <div class="vi-help-guide--video" v-if="data && data.helpDataResourceList.length">
      <m-help-guide-video-item v-for="(el,$index) in data.helpDataResourceList" :item="el" :key="$index"/>
    </div>
    <div class="vi-help--item__more" @click="onToPath">
      <a href="javascript:">了解更多</a>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import mHelpGuideVideoItem from './helpGuideVideoItem'
  import { handleGetBlob, handleSaveAs } from '@/module/utils'
  const prefixCls = 'vi-help-guide'
  export default {
    name: 'vi-help-guide',
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      onToPath () {
        const { data: { type }, helpParams: { reId } } = this
        window.open(`${global.helpToDomain}${type === 2 ? 'guide' : 'direction'}/${reId}`)
      },
      onDownload () {
        const { data } = this
        handleGetBlob(`${global.domainImg()}${data.annexDoc}`).then((res) => {
          handleSaveAs(res, data.docName || (data.type === 2 ? '使用指南' : '运营指导'))
        })
      }
    },
    watch: {},
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['helpParams']),
      classes () {
        return [
          `${prefixCls}`
        ]
      }
    },
    components: { mHelpGuideVideoItem }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-help-guide";
  .#{$-prefix-cls} {
    &--pdf {
      margin-bottom: 6px;
      cursor: pointer;
      i.pdf {
        width: 15px;
        height: 15px;
        background: url("./../img/help_icons_pdf.png") no-repeat;
        display: inline-block;
        vertical-align: middle;
      }
      span {
        font-size: 14px;
        color: #303030;
        vertical-align: middle;
      }
    }
    &--video {
      padding-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/helpGuide.vue